module.exports = __webpack_public_path__ + "img/inco3.8a853d95.png";